import { Navigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

import useAuth from "../../../hooks/useAuth";
import Loading from "../loading/Loading";


const IsAuth = ({ children , forLogin=false}) => {
    
    const { user, error, loading } = useAuth(forLogin);

    // Show loading state while authentication is being checked
    if(loading){
        return <Loading classes="min-h-screen" />;
    }

    // For login page
    if(forLogin){
        // If user is authenticated, redirect to home
        if(user && !isEmpty(user)){
            return <Navigate to="/" replace />;
        }
        // Otherwise, show login page
        return children;
    }

    // For protected routes
    // If not loading and no user, redirect to login
    if(!user || isEmpty(user)){
        return <Navigate to="/login" replace />;
    }

    // If we have a user, show the protected content
    return children;
};

export default IsAuth ;
